import { 
  collection, 
  getDocs, 
  getDoc,
  doc,
  query, 
  where, 
  orderBy, 
  addDoc,
  serverTimestamp,
  Timestamp 
} from "firebase/firestore";
import { db } from "../lib/firebase";

const docToEvent = (id, data) => ({
  id,
  ...data,
  startAt: data.startAt instanceof Timestamp ? data.startAt.toDate().toISOString() : data.startAt,
  endAt: data.endAt instanceof Timestamp ? data.endAt.toDate().toISOString() : data.endAt,
  createdAt: data.createdAt instanceof Timestamp ? data.createdAt.toDate().toISOString() : data.createdAt,
});

export const getActiveEvents = async () => {
  const q = query(
    collection(db, "events"), 
    where("isActive", "==", true),
    where("isDeleted", "==", false),
    orderBy("startAt", "asc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => docToEvent(d.id, d.data()));
};

export const getEventById = async (id) => {
  const docRef = doc(db, "events", id);
  const snap = await getDoc(docRef);
  if (snap.exists()) {
    return docToEvent(snap.id, snap.data());
  }
  return null;
};

export const registerForEvent = async (registrationData) => {
  const docRef = await addDoc(collection(db, "event_registrations"), {
    ...registrationData,
    status: "PENDING",
    registeredAt: serverTimestamp(),
  });
  return docRef.id;
};

export const updateEventRegistrationPayment = async (registrationId, updateData) => {
  const { updateDoc } = await import("firebase/firestore");
  const docRef = doc(db, "event_registrations", registrationId);
  await updateDoc(docRef, {
    ...updateData,
    updatedAt: serverTimestamp(),
  });
};
